/**
 * 聊天会话状态管理（Zustand + 持久化）
 *
 * 职责：
 *   1. 管理 WebSocket/SSE 连接成功后的会话信息
 *   2. 保存 is_guest、session_id、uid 等会话数据
 *   3. setSession 时派发自定义事件（SESSION_READY_EVENT），供页面监听触发历史加载
 */

import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

/** 自定义事件名：session_id 变化时派发 */
export const SESSION_READY_EVENT = "chat-session-ready";

interface ChatSessionState {
  /** 是否是游客模式 */
  is_guest: boolean;
  /** 游客模式标识 */
  session_id: string;
  /** 用户ID */
  uid: number;

  /** 设置会话信息 */
  setSession: (data: { is_guest: boolean; session_id: string; uid: number }) => void;

  /** 清空会话信息 */
  clearSession: () => void;
}

export const useChatSessionStore = create<ChatSessionState>()(
  persist(
    (set) => ({
      // 初始状态
      is_guest: true,
      session_id: "",
      uid: 0,

      // 设置会话信息
      setSession: (data) => {
        console.log("[ChatSessionStore] ★★★★ setSession 被调用!", data);
        set({
          is_guest: data.is_guest,
          session_id: data.session_id,
          uid: data.uid,
        });
        const after = useChatSessionStore.getState();
        console.log("[ChatSessionStore] setSession 后 store 状态:", {
          session_id: after.session_id,
          uid: after.uid,
          is_guest: after.is_guest,
        });
        // ★ 派发全局事件，通知其他模块 session 已就绪
        if (typeof window !== "undefined" && data.session_id) {
          window.dispatchEvent(
            new CustomEvent(SESSION_READY_EVENT, { detail: { session_id: data.session_id } })
          );
        }
      },

      // 清空会话信息
      clearSession: () => {
        set({
          is_guest: true,
          session_id: "",
          uid: 0,
        });
      },
    }),
    {
      name: "chat-session-storage", // localStorage 的 key
      storage: createJSONStorage(() => localStorage),
      // 只持久化会话相关字段
      partialize: (state) => ({
        is_guest: state.is_guest,
        session_id: state.session_id,
        uid: state.uid,
      }),
    },
  ),
);

export default useChatSessionStore;
